import { PcbNodeTypes } from "@buildwithflux/models";
import { filterTruthy } from "../../helpers/arrays";
import { mergeInheritedProps } from "../layout_engine/helpers/propertyInheritance";
export function getMultiRoutingGroups(nets, elements, pcbNodes) {
    if (!nets || !elements) {
        return [];
    }
    const groupsMap = new Map();
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    Object.values(nets).forEach((net) => {
        const pcbNet = pcbNodes[net.uid];
        if (!pcbNet || pcbNet.type !== PcbNodeTypes.net) {
            return;
        }
        // Generates an hash somehow
        const properties = mergeInheritedProps(net, elements);
        const pairProp = properties.controlledImpedancePair &&
            [...properties.controlledImpedancePair]
                .filter((p) => p.value)
                .map((p) => `${p.parentUid}_${p.value}`)
                .sort()[0];
        const busProp = properties.busGroup && [...properties.busGroup].sort()[0];
        const groupUid = filterTruthy([pairProp, busProp]).join("_");
        if (!groupUid) {
            return;
        }
        const prev = groupsMap.get(groupUid) ?? {
            groupUid,
            netUids: [],
            startingNodesUid: {},
        };
        prev.netUids.push(net.uid);
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.values(net.pins).forEach((p) => {
            const existingArray = prev.startingNodesUid[p.elementUid];
            if (!existingArray) {
                prev.startingNodesUid[p.elementUid] = [p.uid];
            }
            else {
                existingArray.push(p.uid);
            }
        });
        groupsMap.set(groupUid, prev);
    });
    return Array.from(groupsMap.values());
}
//# sourceMappingURL=getMultiRoutingGroups.js.map